
import React, { useState, useEffect } from "react";
import styles from "./SlideRecLoader.module.scss";
import starLoader from "img/genai/StarLoader.svg";


const SlideRecLoader = () => {
  const [position, setPosition] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);

  const loadingSteps = [
    { text: "Analysing the selected slide" },
    { text: "Identifying selected slide key message" },
    { text: "Scanning through the other slides" },
    { text: "Recommending the slides for your selection" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setPosition((prev) => prev + 1); // <-- infinite rotation
      setCurrentStep((prev) => (prev + 1) % loadingSteps.length); // <-- text loops
    }, 1000);

    return () => clearInterval(interval);
  }, [loadingSteps.length]);

  const LeftBox = () => (
    <div className={`${styles.rectangleCard} ${styles.shimmer}`}>
      <div className={`${styles.whiteLine} ${styles.shimmer}`}></div>
      <div className={`${styles.whiteLine} ${styles.shimmer}`}></div>
    </div>
  );

  return (
    <>
      <div className={styles.contASlideRec}>
        <LeftBox />
        <LeftBox />
      </div>

      <div className={styles.contBSlideRec}>
        <div className={styles.cardsShowContainer}>
          <div className={styles.progressbox}>
            <div className={styles.progressIndicator}>
              <div className={styles.circularProgress}>
                <svg viewBox="0 0 36 36">
                  <circle
                    className={styles.progressBg}
                    cx="18"
                    cy="18"
                    r="15.9155"
                    strokeWidth="2"
                  />
                  <path
                    className={styles.progressSegment}
                    d="M18 2.0845
                       a 15.9155 15.9155 0 0 1 0 31.831
                       a 15.9155 15.9155 0 0 1 0 -31.831"
                    strokeDasharray="25,90"
                    transform={`rotate(${position * 90} 18 18)`} // <-- infinite spin
                  />
                </svg>
              </div>
              <div className={styles.loadingText}>
                <span>{loadingSteps[currentStep].text}</span>
              </div>
            </div>
          </div>
          <span>
            <img src={starLoader} alt="loader" className={styles.strloader} />
          </span>
        </div>

        <div className={styles.innerBox}>
          <div className={styles.rightSection}>
            {[...Array(6)].map((_, index) => (
              <div key={index} className={`${styles.squareCard} ${styles.shimmer}`}></div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SlideRecLoader;
